import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Miranda Landa Services LLC - Business Capital Consulting & Strategic Funding Advisory</title>
        <meta name="description" content="Professional financial guidance to help businesses explore, evaluate, and prepare for funding opportunities. Expert business capital consulting services." />
      </Helmet>

      {/* Hero Section with Background Image */}
      <section style={{
        position: 'relative',
        minHeight: '600px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        padding: '6rem 2rem',
        textAlign: 'center',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1920&h=1080&fit=crop&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'brightness(0.4)'
        }} />
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(5, 150, 105, 0.9) 0%, rgba(16, 185, 129, 0.8) 100%)'
        }} />
        <div style={{position: 'relative', zIndex: 1, maxWidth: '900px', margin: '0 auto'}} className="fade-in-up">
          <div style={{fontSize: '4rem', marginBottom: '1rem'}}>💼</div>
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1.5rem', lineHeight: '1.2'}}>
            Empowering Businesses with Strategic Capital Consulting
          </h1>
          <p style={{fontSize: '1.3rem', marginBottom: '1rem', opacity: 0.95, lineHeight: '1.6'}}>
            Professional financial guidance to help businesses explore, evaluate, and prepare for funding opportunities
          </p>
          <p style={{fontSize: '1.1rem', marginBottom: '2.5rem', opacity: 0.9, fontWeight: '600'}}>
            ⚠️ We are a consulting firm — NOT a lender
          </p>
          <div style={{display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
            <Link to="/contact" style={{
              background: 'white',
              color: '#059669',
              padding: '1rem 2.5rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
              transition: 'transform 0.3s'
            }}>
              Get Started Today
            </Link>
            <Link to="/services" style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '1rem 2.5rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.1rem',
              border: '2px solid white'
            }}>
              Our Services
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Badge */}
      <section style={{
        background: '#f0fdf4',
        padding: '2rem',
        textAlign: 'center',
        borderBottom: '1px solid #d1fae5'
      }}>
        <p style={{fontSize: '1rem', color: '#065f46', fontWeight: '600'}}>
          ✓ Professional Consulting Firm • ✓ Not a Lender • ✓ Transparent Process • ✓ Verified Financial Partners
        </p>
      </section>

      {/* About Section with Image */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '1rem'}}>
              Your Trusted Financial Advisory Partner
            </h2>
            <p style={{fontSize: '1.2rem', color: '#6b7280', maxWidth: '700px', margin: '0 auto 1.5rem'}}>
              We make the funding process simple, transparent, and reliable
            </p>
            <div style={{
              background: '#fef3c7',
              padding: '1rem 2rem',
              borderRadius: '50px',
              display: 'inline-block',
              border: '2px solid #f59e0b'
            }}>
              <p style={{color: '#92400e', fontWeight: '700', margin: 0}}>
                ⚠️ Important: We are a CONSULTING FIRM, not a lender
              </p>
            </div>
          </div>
          
          <div style={{marginBottom: '4rem'}}>
            <img 
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=400&fit=crop&q=80"
              alt="Business team consultation"
              style={{width: '100%', height: '400px', objectFit: 'cover', borderRadius: '16px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)'}}
            />
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
            <div className="card" style={{textAlign: 'center'}}>
              <div style={{fontSize: '3rem', marginBottom: '1rem'}}>🎯</div>
              <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#059669', marginBottom: '1rem'}}>
                Strategic Guidance
              </h3>
              <p style={{color: '#6b7280', lineHeight: '1.7'}}>
                We help business owners understand their funding options and prepare comprehensive documentation for success.
              </p>
            </div>

            <div className="card" style={{textAlign: 'center'}}>
              <div style={{fontSize: '3rem', marginBottom: '1rem'}}>🤝</div>
              <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#059669', marginBottom: '1rem'}}>
                Verified Partners
              </h3>
              <p style={{color: '#6b7280', lineHeight: '1.7'}}>
                We work exclusively with reputable financial institutions to connect you with the right funding sources.
              </p>
            </div>

            <div className="card" style={{textAlign: 'center'}}>
              <div style={{fontSize: '3rem', marginBottom: '1rem'}}>📊</div>
              <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#059669', marginBottom: '1rem'}}>
                Expert Analysis
              </h3>
              <p style={{color: '#6b7280', lineHeight: '1.7'}}>
                Our team evaluates your business goals and guides you in selecting the right funding paths for growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section style={{padding: '5rem 2rem', background: '#f9fafb'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '1rem'}}>
              Comprehensive Capital Advisory Services
            </h2>
            <p style={{fontSize: '1.2rem', color: '#6b7280'}}>
              Everything you need to prepare for business funding opportunities
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1.5rem'
          }}>
            {[
              { icon: '💡', title: 'Business Capital Consulting', desc: 'Expert advice on funding strategies tailored to your business needs' },
              { icon: '📋', title: 'Funding Preparation Assistance', desc: 'Complete support in preparing your funding applications' },
              { icon: '📄', title: 'Financial Documentation Support', desc: 'Professional help organizing and presenting financial records' },
              { icon: '🔍', title: 'Lender Matching Guidance', desc: 'Connect with the right financial institutions for your goals' },
              { icon: '✅', title: 'Funding Feasibility Review', desc: 'Comprehensive assessment of your funding readiness' },
              { icon: '📈', title: 'Business Growth Strategy', desc: 'Strategic planning for sustainable business expansion' }
            ].map((service, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2rem',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                borderLeft: '4px solid #10b981'
              }}>
                <div style={{fontSize: '2.5rem', marginBottom: '1rem'}}>{service.icon}</div>
                <h3 style={{fontSize: '1.2rem', fontWeight: '700', color: '#064e3b', marginBottom: '0.75rem'}}>
                  {service.title}
                </h3>
                <p style={{color: '#6b7280', fontSize: '0.95rem', lineHeight: '1.6'}}>
                  {service.desc}
                </p>
              </div>
            ))}
          </div>

          <div style={{textAlign: 'center', marginTop: '3rem'}}>
            <Link to="/services" style={{
              background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
              color: 'white',
              padding: '1rem 2.5rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.1rem',
              display: 'inline-block'
            }}>
              View All Services
            </Link>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '1rem'}}>
              How We Help Your Business
            </h2>
            <p style={{fontSize: '1.2rem', color: '#6b7280'}}>
              A simple, transparent process from consultation to funding preparation
            </p>
          </div>

          <div style={{display: 'grid', gap: '2rem'}}>
            {[
              { step: '1', title: 'Initial Consultation', desc: 'We discuss your business goals, funding needs, and current financial situation' },
              { step: '2', title: 'Strategy Development', desc: 'Our experts create a customized funding strategy aligned with your objectives' },
              { step: '3', title: 'Documentation Preparation', desc: 'We help you organize and prepare all necessary financial documentation' },
              { step: '4', title: 'Lender Connection', desc: 'We connect you with verified financial institutions that match your needs' },
              { step: '5', title: 'Ongoing Support', desc: 'Continuous guidance throughout your funding journey and beyond' }
            ].map((item, index) => (
              <div key={index} style={{
                display: 'flex',
                gap: '2rem',
                alignItems: 'flex-start',
                padding: '2rem',
                background: '#f0fdf4',
                borderRadius: '12px'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                  color: 'white',
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  fontWeight: '800',
                  flexShrink: 0
                }}>
                  {item.step}
                </div>
                <div>
                  <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#064e3b', marginBottom: '0.5rem'}}>
                    {item.title}
                  </h3>
                  <p style={{color: '#6b7280', lineHeight: '1.7'}}>
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #064e3b 0%, #059669 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h2 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1.5rem'}}>
            Ready to Explore Your Funding Options?
          </h2>
          <p style={{fontSize: '1.2rem', marginBottom: '2.5rem', opacity: 0.95}}>
            Let our expert consultants guide you through the business capital preparation process
          </p>
          <Link to="/contact" style={{
            background: 'white',
            color: '#059669',
            padding: '1.25rem 3rem',
            borderRadius: '50px',
            fontWeight: '700',
            fontSize: '1.2rem',
            display: 'inline-block',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
          }}>
            Schedule Your Consultation
          </Link>
          <p style={{marginTop: '1.5rem', fontSize: '0.9rem', opacity: 0.8}}>
            ✓ No obligation • ✓ Free initial consultation • ✓ Confidential discussion
          </p>
        </div>
      </section>

      {/* Disclaimer */}
      <section style={{
        background: '#f9fafb',
        padding: '2rem',
        textAlign: 'center',
        borderTop: '1px solid #e5e7eb'
      }}>
        <p style={{fontSize: '0.9rem', color: '#6b7280', maxWidth: '900px', margin: '0 auto'}}>
          <strong>Important:</strong> Miranda Landa Services LLC is a consulting firm that provides business capital advisory services. 
          We are not a lender and do not issue loans directly or make lending decisions. All financing is handled by the verified 
          financial institutions we connect you with. Terms and approval are determined solely by the lender.
        </p>
      </section>
    </>
  );
};

export default Home;
